import { Dispatch } from 'redux';
import { useDispatch, useSelector } from "react-redux"
import { payWithNewCardThunk } from "../thunks/card";
import { useState } from 'react';

interface PayWithNewCardFormProps {
    saveCard: boolean
    setSaveCard: () => void
}

interface AddCardDetailsHtmlForm extends EventTarget {
    cardNumber: { value: string }
    expDate: { value: string }
    cvc: { value: string }
    isDefault: { checked: boolean }
    saveCard: { checked: boolean }
}

function PayWithNewCardForm ({ saveCard, setSaveCard }: PayWithNewCardFormProps) {
    const currentUser: User = useSelector((state: AppState) => state.currentUser)
    const cart: Cart = useSelector((state: AppState) => state.cart);
    const [isLoading, setIsLoading] = useState(false)
    const [cardNumber, setCardNumber] = useState('')
    const [cvc, setCVC] = useState('')
    const [expDate, setExpDate] = useState('')

    const dispatch: Dispatch<any> = useDispatch()

    const onAddCard = async (e: React.SyntheticEvent) => {
        e.preventDefault()
       
        const form = e.target as AddCardDetailsHtmlForm

        // STEP 1: COLLECT FORM VALUES
        const newCardDetails: NewCardDetails = {
            number: form.cardNumber.value.split(' ').join(''),
            expMonth: form.expDate.value.split('/')[0],
            expYear: `20${form.expDate.value.split('/')[1]}`,
            cvc: form.cvc.value,
            isDefault: true
        }

        // STEP 2: CREATE CARD - PASS NEW CARD DETAILS AS PARAMETER
        dispatch(payWithNewCardThunk(currentUser, newCardDetails, form.saveCard.checked, cart.totalAmount))

        setIsLoading(true)
    }

    const handleCardNumberChange = (e: any) => {
        const value: string = e.target.value
        if (/^[0-9\s]*$|^$/.test(value)) {
            setCardNumber(value)
        }
    }
    
    const formatCardNumber = (e: any) => {
        const value = e.target.value
        const count = value.length 
        
        // for every 4 numbers and backspace is not pressed, append space
        if (count < 19 && count % 5 === 4 && e.keyCode !== 8) {
            setCardNumber(`${value.substring(0, count)} `)
        } else {
            setCardNumber(value)
        }

        // if backspace is pressed
        if (count > 0 && count % 5 === 0) {
            if (e.keyCode === 8 && value.slice(-1) === ' ') {
                setCardNumber(value.substring(0, count - 1))
            } else {
                // auto insert space after 4 numbers
                setCardNumber(`${value.substring(0, count - 1)} ${value.substring(count - 1)}`)
            }
        }
    }

    const validateCVC = (e: any) => {
        const value: string = e.target.value
        
        if(/\d$|^$/.test(value)) {
            setCVC(value)
        }
    }

    const handleExpDateChange = (e: any) => {
        const value: string = e.target.value
        const lastChar = value.slice(-1)

        if(/^\d$|^\/|^$/.test(lastChar)) {
            // accept at most only 1 /
            if ((value.match(/\//g) || []).length <= 1) {
                setExpDate(value)
            }
        }
    }

    const formatExpDate = (e: any) => {
        const value = e.target.value
        const count = value.length
        
        // if 2 numbers and backspace is not pressed, append /
        if (/^\d{2}$/.test(value) && e.keyCode !== 8) {
            setExpDate(`${value}/`)
        }

        // if no year
        if (count === 3) {
            // if backspace is pressed, remove / 
            if (e.keyCode === 8) {
                setExpDate(value.replace('/', ''))
            } else {
                // if no / yet, insert / 
                if (!value.includes('/')) {
                    setExpDate(`${value.substring(0, 2)}/${value.substring(2)}`)
                }
            }
        }
    }

    return (
        <form className="add-new-card-form" onSubmit={(e: React.SyntheticEvent) => onAddCard(e)}>
            <div>
                <div className='new-card-info'>
                <input 
                    type="text" 
                    name="cardNumber" 
                    placeholder="Card Number" 
                    maxLength={19}
                    onKeyUp={(e) => formatCardNumber(e)}
                    onChange={(e) => handleCardNumberChange(e)}
                    value={cardNumber}
                    required 
                />
                <input 
                    type="text"
                    name="expDate"
                    placeholder="Date (MM/YY)"
                    minLength={5}
                    maxLength={5}
                    onKeyUp={(e) => formatExpDate(e)}
                    onChange={(e) => handleExpDateChange(e)}
                    value={expDate}
                    required 
                />
                <input 
                    type="text" 
                    name="cvc" 
                    placeholder="CVC"
                    maxLength={4}
                    onChange={(e) => validateCVC(e)}
                    value={cvc}
                    required 
                />
                </div>
                <div className='new-card-settings'>
                    <input type="checkbox" id="saveCard" name="saveCard" checked={saveCard} onChange={setSaveCard} />
                    <label htmlFor='saveCard'> Remember this card </label>
                    <div>
                        <input type="checkbox" id="isDefault" name="isDefault" defaultChecked disabled />
                        <label className="label-default" htmlFor='isDefault'> Set as default </label>
                    </div>
                </div>
            </div>
            <div className='new-card-checkout'>
                <button type="submit" className="btn green"> { isLoading ? <div className='bar-loader'/> : 'Checkout' } </button>
            </div>
        </form>
   )
}

export default PayWithNewCardForm